import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import InitiativeValidations from 'scaleflow/validators/initiative';
import { task } from 'ember-concurrency';

export default class RoadmapTableCreateController extends Controller {
  @service router;
  @tracked submittedOnce = false;
  initiativeValidations = InitiativeValidations;
  @tracked isDisabled = true;

  saveSettings = task({}, async (changeset, e) => {
    e.preventDefault();
    if (changeset.get('isDirty')) {
      this.nothingChanged = false;
      changeset.validate().then(() => {
        if (changeset.get('isValid')) {
          changeset
            .save()
            .then(() => {
              this.submittedOnce = true;
              this.afterSubmit(changeset);
            })
            .catch((err) => {
              console.log(err, 'err');
              changeset
                .get(this, 'model.errors')
                .forEach(({ attribute, message }) => {
                  changeset.addError(attribute, message);
                });
            });
        }
      });
      // if there is an extra action that needs to be done after the form is submitted
    } else {
      this.cancelAll();
    }
  });

  @action
  afterSubmit() {
    const initiative_id = this.model.id;
    this.saveSettings.cancelAll();
    this.router.transitionTo(
      'backlog.initiatives.initiative.description',
      initiative_id,
    );
  }

  @action
  cancelAll() {
    this.saveSettings.cancelAll();
  }

  @action
  resetFormAndRedirect() {
    this.saveSettings.cancelAll();
    this.model.deleteRecord();
    this.router.transitionTo('backlog.initiatives');
  }
}
